<template>
  <!--页面加载动画-->
  <div class="receipt-wrap">
    <p class="tb-title">收据</p>
    <p class="tb-subtitle">收据编号：{{detail.receiptNo}}</p>
    <table class="table-wrap"
           border="1"
           style="table-layout: fixed; word-break: break-all; word-wrap: break-word;">
      <tr>
        <td>
          付款单位
        </td>
        <td>
          {{detail.organizationName}}
        </td>
        <td>
          付款单位纳税人识别号
        </td>
        <td>
          {{detail.taxpayerNum}}
        </td>
      </tr>

      <tr>
        <td>
          收款人姓名
        </td>
        <td>
          {{detail.userName}}
        </td>
        <td>
          收款人证件号
        </td>
        <td>
          {{detail.userIdNo}}
        </td>
      </tr>

      <tr>
        <td>
          人民币(小写)
        </td>
        <td>
          {{detail.amountLowercase}}
        </td>
        <td>
          人民币(大写)
        </td>
        <td>
          {{detail.amountUppercase}}
        </td>
      </tr>
      <tr>
        <td>
          收款事由
        </td>
        <td colspan="3">
          {{detail.reason}}
        </td>

      </tr>
    </table>
    <div class="receipt-name">
      <span>收款人：</span>
      <img @click="$emit('goSign')" :src="form.receiptSign"
           alt=""
           srcset="">
    </div>
    <p class="date">{{detail.withdrawalDate}}</p>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {
      };
    },
    props: ['form','detail'],
    mounted() {},
    methods: {
    }
  };
</script>
  
  <style lang="scss" scoped>
.receipt-wrap {
  background-color: #fff;
  .tb-title {
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    color: #333333;
  }
  .tb-subtitle {
    font-size: 18px;
    color: #333333;
    text-align: right;
  }
  table {
    margin: 15px 0px 30px;
    width: calc(100vw - 60px);
    font-size: 18px;
    color: #333333;
    tr {
      height: 60px;
    }
    td {
      padding: 0 20px;
    }
  }
  .receipt-name,
  .date {
    text-align: right;
    font-size: 20px;
    line-height: 28px;
    color: #333333;
  }
  .receipt-name {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    img {
      max-width: 200px;
      max-height: 200px;
    }
  }
  .date {
    padding-top: 10px;
  }
}
</style>
  